import { FC, Fragment, useEffect, useState } from 'react';
import { Avatar, Button, Dropdown, Menu } from 'antd';
import { TbEdit, TbEye, TbMessageCircle, TbPlus } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { VirtualizedList as List } from '@/shared';
import DropdownButton from '@/shared/components/dropdowns/DropdownButton';
import { DropdownMenuPanel } from '@/shared/components/dropdowns/DropdownPanel';
import { useMemberStore, useWorkspaceStore } from '@/stores';
import { useCollaboratorStore } from '@/stores/database/entities/00-RBAC/99-Collaborators';
import { CollaboratorPermissionType } from '@/types';

interface MemberListItemProps {
    resourceType: any;
    result: any;
    resource: any;
    invites: any;
    input: any;
    setInput: any;
    canInvite: boolean;
}

const MemberListItem: FC<MemberListItemProps> = ({
    resource,
    resourceType,
    result,
    invites,
    input,
    setInput,
    canInvite,
}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    const [permission, setPermission] = useState('View');

    const alreadyInvited = invites?.some((i: any) => i?.member?.id === result?.id);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { selectedWorkspace: workspace } = useWorkspaceStore();
    const { selectedMember: member } = useMemberStore();

    // !TODO: Replace with useParams() logic
    const iID = location.pathname.split('/')[2];

    const resourceId = resource?.id ? resource?.id : iID;

    const disabled = !canInvite || member?.id === result?.id || alreadyInvited;

    const { addCollaborator } = useCollaboratorStore();

    const handleInviteToResource = async () => {
        // if (resourceId && result?.id && workspace?.id) {
        //     try {
        //         await Promise.all([
        //             authorizedAxiosInstance.post(`/api/${resourceType}/${resourceId}/collaborators`, {
        //                 member: result?.id,
        //                 permission,
        //                 status: 'Active',
        //             }),
        //             authorizedAxiosInstance.put(`/api/${resourceType}/${resourceId}`, {
        //                 type: 'Shared',
        //             }),
        //         ]).then((res: AxiosResponse[]) => {
        //             if (res[0].status === 200 && res[1].status === 200) {
        //                 toast('Member Invited', {
        //                     icon: <TbUserPlus size='1rem' />,
        //                     description: result['user']?.emailAddress,
        //                 });

        //                 setInvites([...invites, res[0]?.data]);

        //                 setInput('');

        //                 setLoading(false);
        //             }
        //         });
        //     } catch (error) {
        //         captureException(error);
        //     }
        // } else {
        //     captureException('More values needed to complete');
        // }
        if (!canInvite) {
            return;
        }

        await addCollaborator(resourceType, resource.id, result.id, permission as CollaboratorPermissionType);

        setInput('');
    };

    const { token } = useAntDesignTheme();

    return (
        <>
            <Fragment key={result?.id}>
                <List.Item>
                    <List.Item.Meta
                        avatar={<Avatar src={result['user']?.avatar} style={{ verticalAlign: '-1.5rem' }} />}
                        title={`${result['user']?.firstName} ${result['user']?.lastName}`}
                        description={`${result['user']?.emailAddress}`}
                    />
                    <Dropdown
                        disabled={disabled}
                        placement='bottomRight'
                        trigger={['click']}
                        popupRender={() => (
                            <DropdownMenuPanel
                                disabled={disabled}
                                selectedKeys={[permission]}
                                onClick={(e: any) => {
                                    setPermission(e.key);
                                }}
                            >
                                <Menu.Item key='View'>
                                    <TbEye size='1rem' style={{ marginRight: '0.375rem', verticalAlign: '-0.2rem' }} />
                                    View
                                    <br />
                                    <small style={{ color: token.colorTextSecondary }}>
                                        Ability to view an investment and its related research.
                                    </small>
                                </Menu.Item>
                                <Menu.Item key='Comment'>
                                    <TbMessageCircle
                                        size='1rem'
                                        style={{ marginRight: '0.375rem', verticalAlign: '-0.2rem' }}
                                    />
                                    Comment
                                    <br />
                                    <small style={{ color: token.colorTextSecondary }}>
                                        View permissions + ability to converse with other collaborators.
                                    </small>
                                </Menu.Item>
                                <Menu.Item key='Edit'>
                                    <TbEdit size='1rem' style={{ marginRight: '0.375rem', verticalAlign: '-0.2rem' }} />
                                    Edit
                                    <br />
                                    <small style={{ color: token.colorTextSecondary }}>
                                        Ability to edit the investment and its related research.
                                    </small>
                                </Menu.Item>
                            </DropdownMenuPanel>
                        )}
                    >
                        <DropdownButton disabled={disabled} style={{ marginRight: '0.75rem' }} type='text'>
                            {permission}
                        </DropdownButton>
                    </Dropdown>
                    <Button
                        disabled={disabled}
                        type='dashed'
                        onClick={handleInviteToResource}
                        icon={<TbPlus size='1rem' style={{ marginRight: '0.375rem', verticalAlign: '-0.2rem' }} />}
                    >
                        Invite
                    </Button>
                </List.Item>
            </Fragment>
        </>
    );
};

export default MemberListItem;
